import { translate, configQuery, getFeatureEnabled } from '@gig/magic-common';
import { __awaiter, __generator, __spreadArray } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { Feature } from '@gig/magic-messages';
import { required } from '@gig/magic-form-builder';
import { DocumentType, AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { getIdDocumentTypeOptions, getAddressDocumentTypeOptions, getPaymentDocumentTypeOptions, getSourceOfFundsDocumentTypeOptions, getTranslationKeyForDocType } from './document.utils.js';

function documentType(type, files) {
    var _this = this;
    return {
        id: 'document-type-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'document-type',
        children: [
            {
                id: 'document-type',
                component: 'magic-ui-dropdown',
                isDataField: true,
                testId: 'document-type',
                properties: {
                    placeholder: translate('verification-upload.document.placeholder'),
                },
                validation: [
                    {
                        name: 'required',
                        fn: required,
                    },
                ],
                preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
                    var refreshedFiles, response, err_1, category, filteredFiles, filteredFilesType, allowAllDocumentsUpload, allOptions, options, boOptions_1, configOptionsFiltered;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                refreshedFiles = files;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, magic.methods.users.getUserDocuments()];
                            case 2:
                                response = _a.sent();
                                refreshedFiles = response !== null && response !== void 0 ? response : files;
                                return [3 /*break*/, 4];
                            case 3:
                                err_1 = _a.sent();
                                console.warn('Could not refresh user documents', err_1);
                                return [3 /*break*/, 4];
                            case 4:
                                category = getCategoryByDocumentType(type);
                                filteredFiles = refreshedFiles.filter(function (file) {
                                    return file.category === category &&
                                        file.verificationStatus === AmlStatus.REQUESTED;
                                });
                                filteredFilesType = new Set(filteredFiles.map(function (file) { return file.type; }));
                                return [4 /*yield*/, getFeatureEnabled(Feature.ALLOW_ALL_DOCUMENTS_UPLOAD)];
                            case 5:
                                allowAllDocumentsUpload = _a.sent();
                                return [4 /*yield*/, getOptionsByType(type, allowAllDocumentsUpload)];
                            case 6:
                                allOptions = _a.sent();
                                if (allowAllDocumentsUpload) {
                                    if (filteredFiles.length > 0) {
                                        boOptions_1 = filteredFiles.map(function (file) { return ({
                                            name: translate(getTranslationKeyForDocType(file.type)) + ' (Requested)',
                                            value: file.type,
                                            originalFile: file,
                                        }); });
                                        configOptionsFiltered = (allOptions !== null && allOptions !== void 0 ? allOptions : []).filter(function (option) {
                                            return !boOptions_1.some(function (bo) { return bo.value === option.value; });
                                        });
                                        options = __spreadArray(__spreadArray([], boOptions_1), configOptionsFiltered);
                                    }
                                    else {
                                        options = allOptions !== null && allOptions !== void 0 ? allOptions : [];
                                    }
                                }
                                else {
                                    options = allOptions === null || allOptions === void 0 ? void 0 : allOptions.filter(function (option) {
                                        return filteredFilesType.has(option.value);
                                    });
                                }
                                return [2 /*return*/, { options: options }];
                        }
                    });
                }); },
                converter: function (formValue) {
                    return { Type: formValue['document-type'].value };
                },
            },
        ],
    };
}
function getCategoryByDocumentType(type) {
    switch (type) {
        case DocumentType.PHOTO_ID:
            return 'proof_of_identity';
        case DocumentType.ADDRESS:
            return 'proof_of_address';
        case DocumentType.PAYMENT:
            return 'proof_of_payment';
        case DocumentType.SOURCE_OF_FUNDS:
            return 'source_of_funds';
        default:
            return '';
    }
}
function getOptionsByType(type, allowDocs) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var configDocs;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!allowDocs) return [3 /*break*/, 2];
                    return [4 /*yield*/, configQuery('verificationDocumentTypes')];
                case 1:
                    configDocs = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : {};
                    if (configDocs[type]) {
                        return [2 /*return*/, configDocs[type].map(function (docType) { return ({
                                name: translate(getTranslationKeyForDocType(docType)),
                                value: docType,
                            }); })];
                    }
                    _b.label = 2;
                case 2:
                    if (type === DocumentType.PHOTO_ID) {
                        return [2 /*return*/, getIdDocumentTypeOptions()];
                    }
                    else if (type === DocumentType.ADDRESS) {
                        return [2 /*return*/, getAddressDocumentTypeOptions()];
                    }
                    else if (type === DocumentType.PAYMENT) {
                        return [2 /*return*/, getPaymentDocumentTypeOptions()];
                    }
                    else if (type === DocumentType.SOURCE_OF_FUNDS) {
                        return [2 /*return*/, getSourceOfFundsDocumentTypeOptions()];
                    }
                    return [2 /*return*/];
            }
        });
    });
}

export { documentType, getCategoryByDocumentType, getOptionsByType };
